import { Component, Input } from '@angular/core';

import { IHeaderItem } from 'src/app/models/generic';

@Component({
  selector: 'app-header-list',
  templateUrl: './header-list.component.html',
  styleUrls: ['./header-list.component.scss']
})
export class HeaderListComponent {
  @Input() headerItems: IHeaderItem[] = [];
  @Input() listContractDetail: boolean = false;
  @Input() textCenter: boolean = false;
  @Input() appearance: 'legacy' | 'modern' = 'legacy';

  constructor() {}
}
